import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

function UpdateGasSafeCard({
  uploadCardFrontToClientFunc,
  uploadCardRearToClientFunc,
  inputCardExpiryFunc,
  formError,
}) {
  const frontCameraRef = useRef(null);
  const frontFileRef = useRef(null);
  const rearCameraRef = useRef(null);
  const rearFileRef = useRef(null);
  const [frontFileName, setFrontFileName] = useState(null);
  const [rearFileName, setRearFileName] = useState(null);

  const handleFrontChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFrontFileName(e.target.files[0].name);
      uploadCardFrontToClientFunc(e);
    }
  };

  const handleRearChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setRearFileName(e.target.files[0].name);
      uploadCardRearToClientFunc(e);
    }
  };

  return (
    <div className="row">
      <div className="form-group mb-3">
        <label className="form-label">Front of your Gas Safe Card</label>

        <input ref={frontCameraRef} type="file" accept="image/*" capture="environment" className="d-none" onChange={handleFrontChange} />
        <input ref={frontFileRef} type="file" accept="image/*, .pdf" className="d-none" onChange={handleFrontChange} />

        <div className="d-flex gap-2">
          <button type="button" className="btn btn-outline-secondary btn-sm flex-fill" onClick={() => frontCameraRef.current.click()}>
            📷 Camera
          </button>
          <button type="button" className="btn btn-outline-secondary btn-sm flex-fill" onClick={() => frontFileRef.current.click()}>
            Upload
          </button>
        </div>
        {frontFileName && (
          <p className="text-muted small mt-2 fst-italic mb-0">{frontFileName}</p>
        )}
      </div>

      <div className="form-group mb-3">
        <label className="form-label">Rear of your Gas Safe Card</label>

        <input ref={rearCameraRef} type="file" accept="image/*" capture="environment" className="d-none" onChange={handleRearChange} />
        <input ref={rearFileRef} type="file" accept="image/*, .pdf" className="d-none" onChange={handleRearChange} />

        <div className="d-flex gap-2">
          <button type="button" className="btn btn-outline-secondary btn-sm flex-fill" onClick={() => rearCameraRef.current.click()}>
            📷 Camera
          </button>
          <button type="button" className="btn btn-outline-secondary btn-sm flex-fill" onClick={() => rearFileRef.current.click()}>
            Upload
          </button>
        </div>
        {rearFileName && (
          <p className="text-muted small mt-2 fst-italic mb-0">{rearFileName}</p>
        )}
      </div>

      <div className="form-group mb-3">
        <label htmlFor="inputGasSafeExpiryDate">Date your Gas Safe Card expires</label>
        <input
          type="date"
          className="form-control"
          id="inputGasSafeExpiryDate"
          name="gasSafeExpiryDate"
          onChange={inputCardExpiryFunc}
          required
        />
      </div>
      {formError ? <p className="fw-bold text-danger">*Please fill in all details</p> : <></>}
    </div>
  );
}

UpdateGasSafeCard.propTypes = {
  uploadCardFrontToClientFunc: PropTypes.func.isRequired,
  uploadCardRearToClientFunc: PropTypes.func.isRequired,
  inputCardExpiryFunc: PropTypes.func.isRequired,
  formError: PropTypes.bool.isRequired,
};

export default UpdateGasSafeCard;
